export default {
  'archiveStoreManagement.title': 'Archived Stores',
};
